import axios from '@/libs/axios';
import { ErrorMessage } from '@/libs/Error';

export default class EsMarcaClient {
  constructor() {
    this.api = axios;
    this.error = new ErrorMessage();
  }

  async getCores(queries = {}) {
    try {
      const { data } = await this.api.get('/cores', { params: queries });
      return data;
    } catch (error) {
      throw this.error.message(error, 'Erro ao listar as marcas');
    }
  }
}
